import React from "react";
import { KgInspectorNavLinkRow } from "../../atoms/KgInspectorNavLinkRow";
import { kgInspectorIcons } from "../../kg/canvas/inspector/kgInspectorIcons";
import {
  CountBadge,
  EmptyHint,
  IconSlot,
  LinkRowStack,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "./KgInspectorMetricsTab.styles";
import type { KgInspectorMetricsTabProps } from "./KgInspectorMetricsTab.types";

const MetricIcon = kgInspectorIcons.metric;

const DEFAULT_EMPTY_HINT = "No metrics linked to this table yet.";

export const KgInspectorMetricsTab: React.FC<KgInspectorMetricsTabProps> = ({
  metrics,
  emptyHint = DEFAULT_EMPTY_HINT,
}) => (
  <TabRoot>
    <SectionHeader>
      <IconSlot>
        <MetricIcon size={16} />
      </IconSlot>
      <SectionTitle>Metrics</SectionTitle>
      {metrics.length > 0 && <CountBadge>{metrics.length}</CountBadge>}
    </SectionHeader>

    {metrics.length === 0 ? (
      <EmptyHint>{emptyHint}</EmptyHint>
    ) : (
      <LinkRowStack>
        {metrics.map((metric) => (
          <KgInspectorNavLinkRow
            key={metric.canvasNodeId ?? metric.label}
            link={metric}
          />
        ))}
      </LinkRowStack>
    )}
  </TabRoot>
);

export default KgInspectorMetricsTab;
